export default "__VITE_ASSET__Dkeu5m6R__"